import { useState } from "react";
import { Moon, Sun } from "lucide-react";

export const ThemeToggle = ({ className = "", testid = "theme-toggle" }) => {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));
  const toggle = () => {
    const next = !dark;
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("scbb-theme", next ? "dark" : "light");
    setDark(next);
  };
  return (
    <button type="button" onClick={toggle} data-testid={testid} aria-label={dark ? "Switch to light mode" : "Switch to dark mode"} title={dark ? "Light mode" : "Dark mode"}
      className={`inline-flex items-center gap-2 rounded-full p-2 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground ${className}`}>
      {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
};
